export function formatCurrency(
  value: number,
  currency = 'USD',
  fractionDigitsMin = 2,
  fractionDigitsMax = 2
) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toLowerCase(),
    minimumFractionDigits: fractionDigitsMin,
    maximumFractionDigits: fractionDigitsMax,
  }).format(value);
}
